module.exports = __webpack_public_path__ + "img/Intro-Home.5d298c1b.png";